<template>
  <div class="container">
    <div class="row text--base">
      <BarChart v-if="barTitle" :content="barTitle" />
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import BarChart from '@/components/content/chapter2/BarChart.vue';

export default {
  name: 'App4Bar',
  components: {
    BarChart,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    barTitle() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'bar-chart') : {};
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  }
};
</script>